<template>
  <div>
    <v-row rows="12">
      <v-col md="4" v-for="item in items" :key="item.id">
        <v-card>
          <v-card-title>
            <div class="headline">{{item.name}}</div>
          </v-card-title>
          <v-card-text>            
            <v-select
              @change="setUserStoreGoauth(item.pivot)"
              v-model="item.pivot.google_oauth_id"
              :items="[
                {value: 0, text: 'Selecionar'},
                ...$store.state.google_oauth2.map(g => { 
                  return {  value: g.id, text:g.email}})
              ]"
              label="Agenda de contatos"
              >
            </v-select>
            <v-switch @change="setActive(item.pivot)" v-model="item.pivot.active" label="Ativo"></v-switch>
          </v-card-text>

          <v-card-actions>
            <v-btn @click="$emit('attendStore', item)" text>Atender loja</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {

  name: 'AttendingList',
  props: {
    items: {
      type: Array,
      default () {
        return [];
      }
    },
  },
  methods: {
    setUserStoreGoauth(userStore) {
      if(userStore.active && userStore.google_oauth_id)
        this.$store.dispatch('updateUserStore', userStore);
    },
    setActive(userStore) {
      if (userStore.active && !userStore.google_oauth_id) {
        setTimeout(() => userStore.active = false, 1000);
        this.$store.commit('alertError', 'Selecione a agenda de contatos que deseja utilizar!');
      } else {
        this.$store.dispatch('updateUserStore', userStore);
        this.$store.dispatch('setUserStoreActive', userStore);
      }
    }
  },
  created() {
    this.$store.dispatch('fetchGOauth2');    
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>